/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Single Room
 */

import { Carousel, Col, Container, Row } from 'react-bootstrap';

// Components
import ImgNextGen from '../../../../components/ImgNextGen';
import Form from '../../Contact/Form';

// Styles
import './style.scss'

const SingleRoom = (props) => {
    const {room} = props;
    const formInitialValues = { subject: room.title };

    return(
        <Container className="single-room">
            <Row>
                <div className="single-room__price">
                    <div className="srp-inner">
                        <p>Desde</p>
                        {room.price.value}
                        <sup>{room.price.sup}</sup>
                        <span>{room.price.per}</span>
                    </div>
                </div>
            </Row>

            <Row>
                <Col className="single-room__title text-center">
                    <h2>{room.title}</h2>
                    <p className="mt-5 mb-4">{room.text}</p>
                </Col>
            </Row>

            <Row>
                <Col xl={7} className="mb-4 mb-lg-0">
                    <Carousel>
                        {room.images.map((image, idx) => {
                            return (
                                <Carousel.Item key={idx}>
                                    <ImgNextGen
                                        srcWebp={image.srcWebp}
                                        fallback={image.src}
                                        alt={image.altText}
                                    />
                                
                                </Carousel.Item>
                                );
                        })}
                    </Carousel>
                </Col>

                <Col xl={5} className="single-room__facilities">
                    <h2 className="text-center">Os nossos serviços</h2>
                    
                    <Row className="mt-5">
                        {room.facilities.map((facilities, idx) => {
                            return (
                                <Col key={idx} xl={6}>
                                    <ul>
                                        {facilities.map((facility, sIdx) => {
                                            return <li key={sIdx}>{facility.icon} {facility.text}</li>;
                                        })}
                                    </ul>
                                </Col>
                            );
                        })}
                    </Row>
                </Col>
            </Row>

            <Row className="mt-4">
                <h2 className="text-center">Contacte-nos</h2>
                <Col className="mt-4">
                    <Form initialValues={formInitialValues}/>
                </Col>
            </Row>
        </Container>
    );
}
export default SingleRoom;